import { render, staticRenderFns } from "./TargetedCities.vue?vue&type=template&id=2217f582&scoped=true&"
import script from "./TargetedCities.vue?vue&type=script&lang=js&"
export * from "./TargetedCities.vue?vue&type=script&lang=js&"
import style0 from "./TargetedCities.vue?vue&type=style&index=0&id=2217f582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2217f582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2217f582')) {
      api.createRecord('2217f582', component.options)
    } else {
      api.reload('2217f582', component.options)
    }
    module.hot.accept("./TargetedCities.vue?vue&type=template&id=2217f582&scoped=true&", function () {
      api.rerender('2217f582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/TargetedCities.vue"
export default component.exports